import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import Feedback from './Feedback';


export const LogicManagerFeedbackRoute = () => {
    const [content, setContent] = useState<string>(""); // Inicialize como null
    const navigate = useNavigate()
    const [user,setUserAuth] = useState<any>(null)
    const [p,Setp] = useState<any>(null)
    useEffect(() => {
        fetchP();

    }, []);



    const fetchP = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/feedback`);
        Setp(response.data);
    };

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);
    const sendForm  =async (formData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/feedback`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            fetchP()
        } catch (error: any) {
            if (error.response && error.response.status === 422) {
                alert('Erro de validação: ' + JSON.stringify(error.response.data.errors));
            } else {
                alert('Erro ao adicionar membro: ' + error.message);
            }
        }
    }

    const adicionarMembro = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('content', content);

        sendForm(formData)

    
    
       
    };

    const deletarMembro = async (id) => {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/feedback/${id}`);
        Setp(p.filter((membro) => membro.id !== id));
    };



    const goBackwards = () => {     
        navigate('/manager');       
};

    return (

<div className={styles.wrapper}>
<Board wrapperClass={styles.board}>

        <div className={styles.container}>
            <h1 className={styles.titulo}>Feedback</h1>
            <form onSubmit={adicionarMembro} className="form">
                <input
                    type="text"
                    placeholder="Feedback"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                    />
                <button type="submit" style={{ backgroundColor: 'green', color: 'white' }}>Adicionar Feedback</button>
            </form>
            <div className={styles.lista}>
                {p && p.map((membro) => (
                   <Feedback  feedback={membro} deletarMembro={deletarMembro}/>
                ))}
            </div>
        </div>
                    </Board>
                    <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 
                    </div>
    );
};

